import React, { useEffect, useState } from 'react';
import { DropDownMenu } from './DropDownMenu';
import { Logo } from './Logo';
import { MainTitle } from './MainTitle';
import { Navbar } from './Navbar';
import { Title } from './Title';

export const Header = ({ mobileMode }) => {
  let [styles, setStyles] = useState({
    dropDownMenu: {
      display: 'none',
    },
  });

  const [animations, setAnimations] = useState({
    headerLogo: 'none',
    headerTitle: 'none',
    header: 'none',
    dropDownMenu: 'none',
    designBlocks: 'none',
  });

  const [isMenuOpened, setIsMenuOpened] = useState(false);

  useEffect(() => {
    if (isMenuOpened && !mobileMode) {
      closeMenuWithoutAnimation();
    }
  }, [mobileMode, isMenuOpened]);

  const closeMenuWithoutAnimation = () => {
    setAnimations(curr => {
      return {
        headerLogo: 'headerTextDefault forwards',
        headerTitle: 'headerTextDefault forwards',
        header: 'headerWhite forwards',
        dropDownMenu: 'hideMenu forwards',
        designBlocks: 'designBlocksBlack forwards',
      };
    });

    setStyles({
      dropDownMenu: {
        display: 'none',
      },
    });

    setIsMenuOpened(false);
  };

  const closeMenu = () => {
    setAnimations(curr => {
      return {
        headerLogo: 'headerTextDefault .5s forwards',
        headerTitle: 'headerTextDefault .5s forwards',
        header: 'headerWhite .5s forwards',
        dropDownMenu: 'hideMenu .5s forwards',
        designBlocks: 'designBlocksBlack .5s forwards',
      };
    });

    setTimeout(() => {
      setStyles({
        dropDownMenu: {
          display: 'none',
        },
      });
      setIsMenuOpened(false);
    }, 500);
  };

  const openMenu = () => {
    setStyles({
      dropDownMenu: {
        display: 'flex',
      },
    });

    setAnimations(curr => {
      return {
        headerLogo: 'headerTextWhite .5s forwards',
        headerTitle: 'headerTextWhite .5s forwards',
        header: 'headerBlack .5s forwards',
        dropDownMenu: 'dropMenu .5s forwards',
        designBlocks: 'designBlocksWhite .5s forwards',
      };
    });

    setIsMenuOpened(true);
  };

  const menuHandler = () => {
    isMenuOpened ? closeMenu() : openMenu();
  };

  return (
    <header className="page-header" style={{ animation: animations.header }}>
      <div className="container">
        <div className="main-block" onClick={mobileMode ? menuHandler : null}>
          <Logo animation={animations.headerLogo} />
          <Navbar />
          <Title
            animation={animations.headerTitle}
            animationDesign={animations.designBlocks}
          />
        </div>
        <MainTitle />
      </div>
      <DropDownMenu
        closeMenu={closeMenu}
        animation={animations.dropDownMenu}
        style={styles.dropDownMenu}
      />
    </header>
  );
};
